<div class="inactive-header">
  <div class="inactive-hint">※ 閒置批號: 未停用、批號建立滿 3 個月且期間無任何庫存異動、庫存量為 0。停用後單據將無法再選用該批號，可於「批號明細維護」解除停用。</div>
  <app-vis-button *ngIf="showStopButton && rows.length > 0" [icon]="'block'" [iconCls]="'remove'"
    [label]="'停用已勾選批號 (' + _selectedCount + ')'"
    (click)="onConfirmStop()" [disabled]="isSaving || _selectedCount === 0"></app-vis-button>
</div>

<div *ngIf="!isLoading && rows.length === 0" class="no-data-msg">目前沒有符合條件的閒置批號。</div>

<div *ngIf="rows.length > 0" [class.grid-scroll]="limitGridHeight">
  <app-vis-grid [data]="rows" class="no-border">
    <app-vis-grid-column title="停用" [width]="50">
      <app-vis-grid-column-header>
        <div class="text-center" title="全選/全取消">
          <mat-checkbox [checked]="_allSelected"
                        [indeterminate]="_someSelected"
                        (change)="toggleSelectAll($event.checked)"></mat-checkbox>
        </div>
      </app-vis-grid-column-header>
      <ng-template let-data>
        <div class="text-center">
          <mat-checkbox [(ngModel)]="data.selected"
                        (change)="onSelectChange()"></mat-checkbox>
        </div>
      </ng-template>
    </app-vis-grid-column>
    <app-vis-grid-column field="ProductCode" title="貨號" [width]="90" i18n-title="@@ProductCode">
    </app-vis-grid-column>
    <app-vis-grid-column field="ProductName" title="商品名稱" [width]="260" i18n-title="@@ProductName">
      <ng-template let-data>
        <span class="ellipsis-content" [title]="data.ProductName">{{ data.ProductName }}</span>
      </ng-template>
    </app-vis-grid-column>
    <app-vis-grid-column field="BatchNo" title="批號" [width]="180">
    </app-vis-grid-column>
    <app-vis-grid-column field="ExpirationDate" title="有效日期" [width]="110">
      <ng-template let-data>
        <div class="text-center" [class.text-danger]="isExpired(data)">
          {{ data.ExpirationDate | formatROCFullDate:'/' }}
        </div>
      </ng-template>
    </app-vis-grid-column>
    <app-vis-grid-column field="LastChangeDate" title="最後異動日期" [width]="110">
      <ng-template let-data>
        <div class="text-center">
          <ng-container *ngIf="data.LastChangeDate">{{ data.LastChangeDate | formatROCFullDate:'/' }}</ng-container>
          <span *ngIf="!data.LastChangeDate" class="never-used-text">未曾異動</span>
        </div>
      </ng-template>
    </app-vis-grid-column>
  </app-vis-grid>
</div>
